import API from "../api";
import COMMON_API from "../../../api/common";
export default {
  namespaced: true,
  state: {
    reasons: { total_count: 0, items: [] },
    modalities: []
  },
  mutations: {
    setReasons(state, data) {
      state.reasons = data;
    },
    setListModality(state, data) {
      state.modalities = data;
    }
  },
  actions: {
    async requestReasonList({ commit }, payload) {
      const { data } = await API.getReasonList(payload);
      commit("setReasons", data);
      return data;
    },
    async requestReason(context, id) {
      const { data } = await API.getReason(id);
      return data;
    },
    async requestEditReason(context, { id, payload }) {
      const { data } = await API.putReason({ id, payload });
      return data;
    },
    async requestCreateReason(context, payload) {
      const { data } = await API.postReason(payload);
      return data;
    },
    async requestModalities({ commit }) {
      const { data } = await COMMON_API.getModalities();
      commit("setListModality", data);
      return data;
    }
  },
  modules: {}
};
